<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">订单信息</div>
          <div>
            累计订单：{{ orderData.order_count || 0 }} 总消费：￥{{
              orderData.sum_price || 0
            }}
          </div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
      </div>
    </div>
    <div class="nav acea-row row-around">
      <div
        class="item"
        :class="{ on: type === 0 }"
        @click="$router.replace({ path: '/order/list/0' })"
      >
        <div>待付款</div>
        <div class="num">{{ orderData.unpaid_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 1 }"
        @click="$router.replace({ path: '/order/list/1' })"
      >
        <div>待发货</div>
        <div class="num">{{ orderData.unshipped_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 2 }"
        @click="$router.replace({ path: '/order/list/2' })"
      >
        <div>待收货</div>
        <div class="num">{{ orderData.received_count || 0 }}</div>
      </div>
      <!-- <div
        class="item"
        :class="{ on: type === 3 }"
        @click="$router.replace({ path: '/order/list/3' })"
      >
        <div>待评价</div>
        <div class="num">{{ orderData.evaluated_count || 0 }}</div>
      </div> -->
      <div
        class="item"
        :class="{ on: type === 4 }"
        @click="$router.replace({ path: '/order/list/4' })"
      >
        <div>已完成</div>
        <div class="num">{{ orderData.complete_count || 0 }}</div>
      </div>
    </div>
    <div v-if="orderData.balance_count > 0" class="event_container">
				<router-link class="acea-row row-between event-presell-box" :to="'/order/presell_order_list'" >
					<div class="info">
						<div class="title">预售尾款订单转到这里了！</div>
						<div class="desc">有 <span class="font-color">{{orderData.balance_count}}</span> 笔预售尾款订单待付款，请点击查看</div>
					</div>
					<div class="photo acea-row row-between">
						<div class='picture'>
							<img :src='presellImg' />
						</div>
						<div class="more_btn"><van-icon name="arrow" /></div>
					</div>
				</router-link>
			</div>
    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.combination_id > 0"
              >拼团</span
            ><span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.seckill_id > 0"
              >秒杀</span
            ><span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.bargain_id > 0"
              >砍价</span
            ><span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.presell_id > 0"
              >预售</span
            >
            {{ order._add_time }}
          </div>
          <div class="font-color-red">{{ order._status._title }}</div>
        </div>
        <div @click="$router.push({ path: '/order/detail/' + order.order_id })">
          <div
            class="item-info acea-row row-between row-top"
            v-for="cart in order.cartInfo"
            :key="cart.id"
          >
            <div class="pictrue">
              <!-- 普通 -->
              <img
                :src="cart.productInfo.image"
                @click.stop="
                  $router.push({ path: '/detail/' + cart.productInfo.id })
                "
                v-if="
                  cart.combination_id === 0 &&
                    cart.bargain_id === 0 &&
                    cart.seckill_id === 0
                "
              />
              <!-- 拼团 -->
              <img
                :src="cart.productInfo.image"
                @click.stop="
                  $router.push({
                    path: '/activity/goods_combination_details?id=' + cart.combination_id
                  })
                "
                v-else-if="cart.combination_id > 0"
              />
              <!-- 砍价 -->
              <img
                :src="cart.productInfo.image"
                @click.stop="
                  $router.push({
                    path: `/activity/goods_bargain_details?id=${cart.bargain_id}&bargain=${userInfo.uid}`
                  })
                "
                v-else-if="cart.bargain_id > 0"
              />
              <img
                :src="cart.productInfo.image"
                @click.stop="
                  $router.push({
                    path: '/activity/seckill_detail/' + cart.seckill_id
                  })
                "
                v-else-if="cart.seckill_id > 0"
              />
            </div>
            <div class="text acea-row row-between">
              <div class="name line2">
                {{ cart.productInfo.store_name }}
              </div>
              <div class="money">
                <div>
                  ￥{{
                    cart.productInfo.attrInfo
                      ? cart.productInfo.attrInfo.price
                      : cart.productInfo.price
                  }}
                </div>
                <div>x{{ cart.cart_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          共{{ order.cartInfo.length || 0 }}件商品，总金额
          <span
            v-if="order.presell_id > 0" 
            class="money font-color-red">￥{{ order.presell_price }}</span>
          <span
            v-else 
            class="money font-color-red">￥{{ order.pay_price }}</span>
        </div>
        <div class="bottom acea-row row-right row-middle">
          <template
            v-if="order._status._type === 0 || order._status._type == 9"
          >
            <div class="bnt cancelBnt" @click="cancelOrder(order)">
              取消订单
            </div>
          </template>
          <template v-if="order._status._type === 0">
            <div class="bnt bg-color-red" @click="paymentTap(order)">
              立即付款
            </div>
          </template>
          <template
            v-if="order._status._type === 1 || order._status._type === 9"
          >
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              查看详情
            </div>
          </template>
          <template v-if="order._status._type === 2">
            <div
              class="bnt default"
              @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              "
              v-if="order.delivery_type === 'express'"
            >
              查看物流
            </div>
            <div class="bnt bg-color-red" @click="takeOrder(order)">
              确认收货
            </div>
          </template>
          <template v-if="order._status._type === 3">
            <div
              class="bnt default"
              @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              "
              v-if="order.delivery_type === 'express'"
            >
              查看物流
            </div>
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              去评价
            </div>
          </template>
          <template v-if="order._status._type === 4">
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              查看订单
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>
<script>
import { getOrderData, getOrderList } from "@api/order";
import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle
} from "@libs/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import GeneralWindow from "@components/GeneralWindow";
import Icon from "vant/lib/icon";
import "vant/lib/icon/style";

const STATUS = [
  "待付款",
  "待发货",
  "待收货",
  "待评价",
  "已完成",
  "",
  "",
  "",
  "",
  "待付款"
];

const NAME = "MyOrder";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: [ "weixin"],
      from: isWeixin() ? "weixin" : "weixinh5",
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      preSellOrderList:[],  //预售订单
      presellImg:""
    };
  },
  components: {
    Loading,
    Payment,
    GeneralWindow,
    [Icon.name]: Icon,
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
        }
        this.getOrderData();
      }
    }
  },
  methods: {
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    getOrderData() {
      getOrderData().then(res => {
        this.orderData = res.data;
      });
    },
    takeOrder(order) {
      this.$dialog.loading.open("正在加载中");
      takeOrderHandle(order.order_id)
        .then(res => {
          if (
            (res.data.gain_integral != "0.00" &&
              res.data.gain_coupon != "0.00") ||
            (res.data.gain_integral > 0 && res.data.gain_coupon > 0)
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${res.data.gain_coupon}元优惠券以及${
                res.data.gain_integral
              }积分，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠礼包"
            };
            return;
          } else if (
            res.data.gain_integral != "0.00" ||
            res.data.gain_integral > 0
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${
                res.data.gain_integral
              }积分，购买商品时可抵现哦～`,
              title: "赠送积分"
            };
            return;
          } else if (
            res.data.gain_coupon != "0.00" ||
            res.data.gain_coupon > 0
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${
                res.data.gain_coupon
              }元优惠券，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠券"
            };
            return;
          } else {
            this.$dialog.loading.close();
            this.$dialog.success("收货成功");
          }
          this.getOrderData();
          this.orderList = [];
          this.page = 1;
          this.loaded = false;
          this.loading = false;
          this.getOrderList();
        })
        .catch(err => {
          this.$dialog.loading.close();
          this.$dialog.error(err.msg);
        });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getOrderData();
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;
      getOrderList({
        page,
        limit,
        type
      }).then(res => {
        
        this.orderList = this.orderList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },
    getStatus(order) {
      return STATUS[order._status._type];
    },
    cancelOrder(order) {
      cancelOrderHandle(order.order_id)
        .then(() => {
          this.getOrderData();
          this.orderList.splice(this.orderList.indexOf(order), 1);
        })
        .catch(() => {
          this.reload();
        });
    },
    paymentTap: function(order) {
      var that = this;
      if (
        !(
          order.combination_id > 0 ||
          order.bargain_id > 0 ||
          order.seckill_id > 0
        )
      ) {
        that.setOfflinePayStatus(order.offlinePayStatus);
      }
      this.pay = true;
      this.toPay = type => {
        payOrderHandle(order.order_id, type, that.from)
          .then(() => {
            const type = parseInt(this.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          })
          .catch(res => {
            if (res.status === "WECHAT_H5_PAY")
              return that.$router.push({
                path: "/order/status/" + order.order_id + "/5"
              });
            const type = parseInt(that.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          });
      };
    },
    toPay() {},
    /**
     * 获取定金预售订单列表
     */
    getpreSellOrderList(){
      
      let that = this;
      let data = {
        type : 10,
        page:1,
        limit:1
      }
      getOrderList(data).then(res => {
        let list = res.data || [];
        that.$set(that,'preSellOrderList',list);
        that.presellImg = that.preSellOrderList[0].cartInfo[0].productInfo.image;
      })
    }
  },
  
  mounted() {
    this.getOrderData();
    this.getOrderList();
    this.getpreSellOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.event_container{
  width: 6.9rem;
	background-image: url('data:image/png;base64,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');
	background-size: cover;
	background-repeat: no-repeat;
	margin: .2rem auto;
	padding: .26rem .3rem;
	border-radius: 8px;
}
.event_container .event-presell-box{
  align-items: center;
}
.event_container .info{
  width:4.2rem;
}
.event_container .info .title{
  color: #282828;
  font-size: .26rem;
}
.event_container .info .desc{
    color: #999;
    font-size: .24rem;
    margin-top: .3rem;
}
.event_container .info .desc .font-color{
  color: #fc4141!important;
}
.event_container .photo{
  width: 1.8rem;
}
.event_container .photo .picture{
  width: 1.2rem;
  height: 1.2rem;
}
.event_container .photo .picture img{
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.event_container .photo .more_btn{
  color: #fff;
  background: #f97e3b;
  width: .4rem;
  height: .4rem;
  border-radius: 20px;
  text-align: center;
  line-height: .4rem;
  position: relative;
  top: .4rem;
}
.event_container .photo .more_btn i{
  vertical-align: middle;
}
</style>
